import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WishlistService } from '../services/raintree/Transmission/wishlist.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DpSuccessMessageComponent } from '../common-component/dp-success-message/dp-success-message.component';

@Component({
  selector: 'img-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="img-div cursor-pointer">
      <img
        class="img-content"
        src="../../../assets/images/delete.svg"
        (click)="onCellClick(data)"
      />
    </div>
  `,
  styles: [
    `
      .img-div {
        padding: 4px 8px;
      }

      .img-content {
        height: 2rem;
        width: 2rem;
      }
    `,
  ],
})
export class ImageCellComponent {
  @Input() data: any;
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  onCellClick(data: any) {
    this.cellClick.emit(this.rowData);
  }
}
